/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * Standard error response object
 */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdPauseErrorResponseData =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/**
 * Standard error response object
 */
export class PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdPauseErrorResponse
  extends Error
{
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;

  /** The original data that was passed to this error instance. */
  data$:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdPauseErrorResponseData;

  constructor(
    err:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdPauseErrorResponseData,
  ) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.error = err.error;
    if (err.code != null) this.code = err.code;
    if (err.details != null) this.details = err.details;

    this.name =
      "PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdPauseErrorResponse";
  }
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdPauseErrorResponse$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdPauseErrorResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    error: z.string(),
    code: z.string().optional(),
    details: z.nullable(z.any()).optional(),
  })
    .transform((v) => {
      return new PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdPauseErrorResponse(
        v,
      );
    });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdPauseErrorResponse$Outbound =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdPauseErrorResponse$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdPauseErrorResponse$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdPauseErrorResponse
  > = z.instanceof(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdPauseErrorResponse,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      error: z.string(),
      code: z.string().optional(),
      details: z.nullable(z.any()).optional(),
    }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdPauseErrorResponse$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdPauseErrorResponse$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdPauseErrorResponse$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdPauseErrorResponse$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdPauseErrorResponse$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdPauseErrorResponse$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdPauseErrorResponse$Outbound;
}
